import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { BENEFICIARY, PETITIONER } from 'app-models';
import { NoteDialogConfigurations } from 'dialog-configuration-library';
import { NoteDialogComponentLibraryComponent, NoteDialogComponentLibraryModule } from 'note-dialog-component-library';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getSubTaskDetails } from 'visa-store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as i1 from 'primeng/dynamicdialog';
import * as i3 from 'primeng/tooltip';
import * as i4 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class NotificationComponentLibrary {
    constructor(dialogService, store) {
        this.dialogService = dialogService;
        this.store = store;
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        this.store.pipe(select(getSubTaskDetails))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            if (data && data.id) {
                this.immSpecialistId = data.immSpecialistId;
            }
        });
    }
    handleNotification(item) {
        NoteDialogConfigurations.data = {
            title: `Missing Document - ${item.fileCategory.name} `,
            payload: {
                beneficiaryId: this.destination === BENEFICIARY ? this.stepDetails.beneficiaryId : null,
                companyId: this.stepDetails.companyId ? this.stepDetails.companyId : null,
                employeeId: this.destination === PETITIONER ? this.immSpecialistId : null,
                notificationType: "DOCMISS",
                text: null,
                title: null,
                data: JSON.stringify({
                    petitionId: this.primaryData.caseId,
                    taskId: this.stepDetails.taskId || null,
                    documentType: item.fileCategory.name,
                    documentCategory: item.fileCategory.group
                }),
                channelType: "",
                notifyAllBeneficiaries: false,
                notifyAllEmployees: false,
                priority: "",
            }
        };
        this.dialogService.open(NoteDialogComponentLibraryComponent, NoteDialogConfigurations);
    }
}
NotificationComponentLibrary.ɵfac = function NotificationComponentLibrary_Factory(t) { return new (t || NotificationComponentLibrary)(i0.ɵɵdirectiveInject(i1.DialogService), i0.ɵɵdirectiveInject(i2.Store)); };
NotificationComponentLibrary.ɵcmp = i0.ɵɵdefineComponent({ type: NotificationComponentLibrary, selectors: [["notification-component-library"]], inputs: { stepDetails: "stepDetails", primaryData: "primaryData", disabledControls: "disabledControls", item: "item", destination: "destination" }, decls: 1, vars: 1, consts: [["type", "button", "pTooltip", "Notify", "pButton", "", "icon", "pi pi-bell", 1, "p-button-text", "p-button-rounded", 2, "color", "#4a4a4a", 3, "disabled", "click"]], template: function NotificationComponentLibrary_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function NotificationComponentLibrary_Template_button_click_0_listener() { return ctx.handleNotification(ctx.item); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.disabledControls);
    } }, directives: [i3.Tooltip, i4.ButtonDirective], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationComponentLibrary, [{
        type: Component,
        args: [{
                selector: 'notification-component-library',
                templateUrl: './notification-component-library.component.html',
                styles: []
            }]
    }], function () { return [{ type: i1.DialogService }, { type: i2.Store }]; }, { stepDetails: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], disabledControls: [{
            type: Input
        }], item: [{
            type: Input
        }], destination: [{
            type: Input
        }] }); })();

class NotificationComponentLibraryModule {
}
NotificationComponentLibraryModule.ɵfac = function NotificationComponentLibraryModule_Factory(t) { return new (t || NotificationComponentLibraryModule)(); };
NotificationComponentLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: NotificationComponentLibraryModule });
NotificationComponentLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            NoteDialogComponentLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NotificationComponentLibraryModule, { declarations: [NotificationComponentLibrary], imports: [PrimengLibraryModule,
        NoteDialogComponentLibraryModule], exports: [NotificationComponentLibrary] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationComponentLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [NotificationComponentLibrary],
                imports: [
                    PrimengLibraryModule,
                    NoteDialogComponentLibraryModule
                ],
                exports: [NotificationComponentLibrary]
            }]
    }], null, null); })();

/*
 * Public API Surface of notification-component-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NotificationComponentLibrary, NotificationComponentLibraryModule };
//# sourceMappingURL=notification-component-library.js.map
